import React from 'react';

import Ipaddressplan from './ipaddressplan/'


const Internalrequests = props => {


  return (


      <div>
          {props.section === 'ipaddressplan'?         <Ipaddressplan /> : null }


      </div>
  )
}

export default Internalrequests
